import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const AdvancedSearchModal = ({ isOpen, onClose, onSearch }) => {
  const [queryBuilder, setQueryBuilder] = useState([
    { id: 1, field: 'fullName', operator: 'contains', value: '', logic: 'AND' }
  ]);

  if (!isOpen) return null;

  const fieldOptions = [
    { value: 'fullName', label: 'Vollständiger Name' },
    { value: 'clientId', label: 'Klienten-ID' },
    { value: 'birthDate', label: 'Geburtsdatum' },
    { value: 'occupation', label: 'Beruf' },
    { value: 'email', label: 'E-Mail' },
    { value: 'phone', label: 'Telefon' },
    { value: 'address', label: 'Adresse' },
    { value: 'status', label: 'Status' },
    { value: 'caseWorker', label: 'Sachbearbeiter' }
  ];

  const operatorOptions = [
    { value: 'contains', label: 'Enthält' },
    { value: 'equals', label: 'Gleich' },
    { value: 'notEquals', label: 'Nicht gleich' },
    { value: 'startsWith', label: 'Beginnt mit' },
    { value: 'endsWith', label: 'Endet mit' },
    { value: 'greaterThan', label: 'Größer als' },
    { value: 'lessThan', label: 'Kleiner als' }
  ];

  const logicOptions = [
    { value: 'AND', label: 'UND' },
    { value: 'OR', label: 'ODER' }
  ];

  const addCondition = () => {
    setQueryBuilder([
      ...queryBuilder,
      { id: Date.now(), field: 'fullName', operator: 'contains', value: '', logic: 'AND' }
    ]);
  };

  const removeCondition = (id) => {
    setQueryBuilder(queryBuilder?.filter(q => q?.id !== id));
  };

  const updateCondition = (id, key, value) => {
    setQueryBuilder(queryBuilder?.map(q => 
      q?.id === id ? { ...q, [key]: value } : q
    ));
  };

  const handleSearch = () => {
    onSearch(queryBuilder);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Erweiterte Suche</h2>
            <p className="text-sm text-muted-foreground mt-1">Erstellen Sie komplexe Suchabfragen mit mehreren Bedingungen</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={20} className="text-muted-foreground" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            {queryBuilder?.map((condition, index) => (
              <div key={condition?.id} className="space-y-3">
                {index > 0 && (
                  <div className="flex items-center gap-2">
                    <div className="h-px flex-1 bg-border"></div>
                    <Select
                      options={logicOptions}
                      value={condition?.logic}
                      onChange={(value) => updateCondition(condition?.id, 'logic', value)}
                      className="w-32"
                    />
                    <div className="h-px flex-1 bg-border"></div>
                  </div>
                )}
                
                <div className="flex items-start gap-3 p-4 bg-muted/30 rounded-lg">
                  <div className="flex-1 grid grid-cols-3 gap-3">
                    <Select
                      label="Feld"
                      options={fieldOptions}
                      value={condition?.field}
                      onChange={(value) => updateCondition(condition?.id, 'field', value)}
                      searchable
                    />
                    
                    <Select
                      label="Operator"
                      options={operatorOptions}
                      value={condition?.operator}
                      onChange={(value) => updateCondition(condition?.id, 'operator', value)}
                    />
                    
                    <Input
                      label="Wert"
                      type="text"
                      placeholder="Wert eingeben..."
                      value={condition?.value}
                      onChange={(e) => updateCondition(condition?.id, 'value', e?.target?.value)}
                    />
                  </div>
                  
                  {queryBuilder?.length > 1 && (
                    <button
                      onClick={() => removeCondition(condition?.id)}
                      className="mt-8 p-2 hover:bg-destructive/10 text-destructive rounded transition-colors"
                    >
                      <Icon name="Trash2" size={18} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <Button
            variant="outline"
            iconName="Plus"
            iconPosition="left"
            onClick={addCondition}
            className="mt-4"
          >
            Bedingung hinzufügen
          </Button>

          <div className="mt-6 p-4 bg-muted/30 rounded-lg">
            <h3 className="text-sm font-medium text-foreground mb-3">Zusätzliche Optionen</h3>
            <div className="space-y-2">
              <Checkbox label="Nur aktive Klienten einbeziehen" />
              <Checkbox label="Duplikate hervorheben" />
              <Checkbox label="Nur Klienten mit ausstehenden Aufgaben" />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="default" iconName="Search" iconPosition="left" onClick={handleSearch}>
            Suche ausführen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSearchModal;